// extracted by mini-css-extract-plugin
export var chevronIcon = "_dj-2";
export var teamName = "_dj-1";
export var teamSwitcherButton = "_dj-0";